import { createReducer } from 'redux-act';
import { fetchPresetsAction, fetchPresetsSuccessAction } from '../../actions';
import { IShopSalesAutomation } from '../../types';
import { DesignColors } from '../../constants/colorPresets';
import { IImage } from '..';

export interface IPreset {
  comments: boolean;
  default: boolean;
  download: boolean;
  downloadPin: boolean;
  galleries: any[];
  galleryStyle: string;
  shopCtaPlacement: string;
  language: number;
  name: string;
  sharing: boolean;
  showAppInstall: boolean;
  showImageCaptionInGallery: boolean;
  _userbrand: string;
  _id: string;
  _user: string;
  _domain: string;
  _watermark: string;
  _scrappbookGalleryTemplate: string;
  styles: {
    backgroundColor: string;
    buttonColor: string;
  };
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  ga_id: string;
  showOnlyPurchasedPrints: boolean;
  gtm_id: string;
  fb_pixel_id: string;
  shopActive: boolean;
  _productPricingList: string;
  salesAutomationConfig: IShopSalesAutomation;
  design: {
    disableDecorations: boolean;
    loadFonts: string[];
    imageSpacing: '';
    reactionSet?: string;
    iconSet?: string;
    variables: {
      [key: string]: string;
    };
    newColorPreset?: string;
    newUseCustomColors?: boolean;
    newVariables: DesignColors;
  };
  digitalShop: {
    enabled: boolean;
    manualOrderProcessing: boolean;
    digitalPricingList: string | null;
    alreadyPurchasedTier: string | null;
  };
  headerImage?: IImage;
  tags?: string[];
  expiresInDays?: number | null;
  messages?: string[];
  faceRecognition: {
    enabled: boolean;
  };
}

export interface IPresetsReducerState {
  presetsItems: IPreset[];
  isListFetched: boolean;
}

const initialState: IPresetsReducerState = {
  presetsItems: [],
  isListFetched: false
};

export const presets = createReducer<IPresetsReducerState>({}, initialState);
presets.on(fetchPresetsAction, (state: IPresetsReducerState) => ({
  ...state,
  isListFetched: true
}));
presets.on(fetchPresetsSuccessAction, (state: IPresetsReducerState, payload: IPreset[]) => ({
  ...state,
  presetsItems: payload
}));
